import React, { useState } from 'react';
import './MobileContactPage.css';

export default function MobileContactPage(){
  const [formData, setFormData] = useState({ fullName:'', email:'', subject:'', message:'' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const subjectOptions = [
    { value:'', label:'Select a subject' },
    { value:'general', label:'General Inquiry' },
    { value:'technical', label:'Technical Support' },
    { value:'partnership', label:'Partnership' },
    { value:'feedback', label:'Feedback' },
    { value:'other', label:'Other' }
  ];

  function validate(){
    const next = {};
    if(!formData.fullName.trim()) next.fullName = 'Full name is required';
    if(!formData.email.trim()) next.email = 'Email is required';
    else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) next.email = 'Enter a valid email';
    if(!formData.subject) next.subject = 'Pick a subject';
    if(!formData.message.trim()) next.message = 'Message is required';
    else if(formData.message.trim().length < 10) next.message = 'Message must be at least 10 characters';
    setErrors(next); return Object.keys(next).length === 0;
  }

  function onChange(e){
    const { name, value } = e.target;
    setFormData(d => ({ ...d, [name]: value }));
    if(errors[name]) setErrors(err => ({ ...err, [name]: undefined }));
  }

  async function onSubmit(e){
    e.preventDefault();
    if(!validate()) return;
    setLoading(true);
    await new Promise(r => setTimeout(r, 900)); // simulate
    setLoading(false); setSubmitted(true);
    setFormData({ fullName:'', email:'', subject:'', message:'' });
  }

  if(submitted){
    return (
      <div className="mobile-contact-page">
        <header className="mcp-header">
          <a href="/m" className="mcp-home-btn" aria-label="Go home">
            <svg className="mcp-home-ic" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="mcpHomeGrad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#6b7280"/><stop offset="55%" stopColor="#9ca3af"/><stop offset="100%" stopColor="#d1d5db"/></linearGradient></defs><path d="M4 11.5 12 5l8 6.5v6.2c0 .9-.7 1.6-1.6 1.6H5.6c-.9 0-1.6-.7-1.6-1.6v-6.2Z" fill="url(#mcpHomeGrad)" stroke="rgba(15,32,58,0.15)" strokeWidth="1" strokeLinejoin="round"/><path d="M9.75 19.3v-4.1c0-.7.55-1.2 1.25-1.2h2c.7 0 1.25.5 1.25 1.2v4.1" fill="none" stroke="#fff" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" opacity="0.85"/></svg>
          </a>
          <h1 className="mcp-title">Message Sent</h1>
          <p className="mcp-sub">We'll get back to you within 1–2 business days. Thank you for reaching out.</p>
          <div className="mcp-accent" />
        </header>
        <div className="mcp-confirm-card">
          <div className="mcp-confirm-icon" aria-hidden="true">✅</div>
          <p className="mcp-confirm-text">Want to send another? Tap below.</p>
          <button className="mcp-reset-btn" onClick={()=> setSubmitted(false)}>Send Another Message</button>
        </div>
      </div>
    );
  }

  return (
    <div className="mobile-contact-page">
      <header className="mcp-header">
        <a href="/m" className="mcp-home-btn" aria-label="Go home">
          <svg className="mcp-home-ic" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="mcpHomeGrad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#6b7280"/><stop offset="55%" stopColor="#9ca3af"/><stop offset="100%" stopColor="#d1d5db"/></linearGradient></defs><path d="M4 11.5 12 5l8 6.5v6.2c0 .9-.7 1.6-1.6 1.6H5.6c-.9 0-1.6-.7-1.6-1.6v-6.2Z" fill="url(#mcpHomeGrad)" stroke="rgba(15,32,58,0.15)" strokeWidth="1" strokeLinejoin="round"/><path d="M9.75 19.3v-4.1c0-.7.55-1.2 1.25-1.2h2c.7 0 1.25.5 1.25 1.2v4.1" fill="none" stroke="#fff" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" opacity="0.85"/></svg>
        </a>
        <h1 className="mcp-title">Contact Us</h1>
        <p className="mcp-sub">Questions, feedback, partnerships – drop us a line and we'll respond promptly.</p>
        <div className="mcp-accent" />
      </header>
      <form className="mcp-form" onSubmit={onSubmit} noValidate>
        <div className="mcp-field">
          <label htmlFor="fullName">Full Name <span>*</span></label>
          <input id="fullName" name="fullName" value={formData.fullName} onChange={onChange} placeholder="Jane Doe" className={errors.fullName? 'err': ''} />
          {errors.fullName && <div className="mcp-err-msg">{errors.fullName}</div>}
        </div>
        <div className="mcp-field">
          <label htmlFor="email">Email <span>*</span></label>
          <input id="email" name="email" type="email" value={formData.email} onChange={onChange} placeholder="you@example.com" className={errors.email? 'err': ''} />
          {errors.email && <div className="mcp-err-msg">{errors.email}</div>}
        </div>
        <div className="mcp-field">
          <label htmlFor="subject">Subject <span>*</span></label>
          <select id="subject" name="subject" value={formData.subject} onChange={onChange} className={errors.subject? 'err': ''}>
            {subjectOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
          </select>
          {errors.subject && <div className="mcp-err-msg">{errors.subject}</div>}
        </div>
        <div className="mcp-field">
          <label htmlFor="message">Message <span>*</span></label>
          <textarea id="message" name="message" rows="5" value={formData.message} onChange={onChange} placeholder="Tell us how we can help" className={errors.message? 'err': ''} />
          {errors.message && <div className="mcp-err-msg">{errors.message}</div>}
        </div>
        <button type="submit" className="mcp-submit" disabled={loading}>{loading? 'Sending…' : 'Send Message'}</button>
      </form>
    </div>
  );
}
